import React, { useState } from 'react';
import ActivoForm from './ActivoForm';
import ActivoGrid from './ActivoGrid';

const EmpresaDetalle = ({ empresa }) => {
  const [activos, setActivos] = useState([]);

  const agregarActivo = (activo) => {
    setActivos([...activos, activo]);
  };

  return (
    <div className="container">
      <h2 className="titulo">{empresa.nombre}</h2>
      <p><b>RFC:</b> {empresa.rfc}</p>
      <ActivoForm onAdd={agregarActivo} />
      <ActivoGrid activos={activos} />
    </div>
  );
};

export default EmpresaDetalle;